<ph-dialog [open]="open" [size]="size" heading="Add a Bill Payment Bank Account" (ph-close)="closed.emit(null)">
    <ph-skeleton *ngIf="!isPreferencesLoaded" shape="list" rows="3" label="Loading"></ph-skeleton>

    <ph-stack *ngIf="isPreferencesLoaded && !isManualAddEnabled">
        <h3>Temporarily Restricted</h3>
        <div>Please contact PayHOA to enable creation of bill pay accounts for this organization.</div>
    </ph-stack>

    <ph-card *ngIf="isPreferencesLoaded && isManualAddEnabled && !isTermsAgreedTo && isMemberDataLoaded"
             heading="Terms and Conditions"
             subheading="In order to use the Bill Pay service, you are required to agree to the terms and conditions below."
             subheading-wrap>
        <ph-scroll-area max-height="240px">
            You represent and warrant, that your use of the Service or the Website shall not in any way,
            directly or indirectly: a) violate any law, statute, contract or regulation relating to money
            laundering, illegal gambling activities, support for terrorist activities, fraud or theft, and/or
            (b) violate any of these Terms of Service. PayHOA will cooperate fully with law enforcement in the
            detection or prosecution of illegal activities to the fullest extent permitted or required by
            applicable law.
        </ph-scroll-area>
    </ph-card>

    <ph-stack *ngIf="isPreferencesLoaded && isManualAddEnabled && isTermsAgreedTo && isMemberDataLoaded">
        <ng-container *ngIf="membership?.lobBankAccounts?.length > 0">
            <ph-field *ngIf="unverifiedAccounts?.length > 0">
                <ph-label>Verify an account:</ph-label>
                <ph-select placeholder="Select account"
                           aria-label="Verify an account"
                           [items]="unverifiedAccountItems"
                           (ph-change)="onVerifyAccountSelected($event.detail)"></ph-select>
            </ph-field>
            <div>
                You can manage your bill pay accounts from your
                <a [routerLink]="['/app/settings/user/financial-accounts']">wallet</a>.
            </div>
        </ng-container>

        <div>
            After adding your bank account, it will take 2-3 days to confirm your bank account ownership.
            Watch your account for 2 small deposits and come back to enter them here.
            Once your account is confirmed, you can use it to pay bills here.
        </div>

        <form [formGroup]="model">
            <ph-columns min="240px">
                <ph-field>
                    <ph-label required>Account Description</ph-label>
                    <ph-input formControlName="description"
                              ngDefaultControl
                              name="description"
                              required
                              type="text"
                              [hasError]="isInvalid('description')"></ph-input>
                    <lf-control-messages hint [control]="model.controls['description']"></lf-control-messages>
                </ph-field>
                <ph-field>
                    <ph-label required>Check Signature Name</ph-label>
                    <ph-input formControlName="signatory"
                              ngDefaultControl
                              name="signatory"
                              required
                              maxlength="30"
                              type="text"
                              [hasError]="isInvalid('signatory')"></ph-input>
                    <lf-control-messages hint [control]="model.controls['signatory']"></lf-control-messages>
                </ph-field>
            </ph-columns>
            <ph-columns min="240px">
                <ph-field>
                    <ph-label required>Routing Number (9 digits)</ph-label>
                    <ph-input formControlName="routingNumber"
                              ngDefaultControl
                              name="routingNumber"
                              [maxlength]="9"
                              [minlength]="9"
                              required
                              type="text"
                              [hasError]="isInvalid('routingNumber')"></ph-input>
                    <lf-control-messages hint [control]="model.controls['routingNumber']"></lf-control-messages>
                </ph-field>
                <ph-field>
                    <ph-label required>Account Number</ph-label>
                    <ph-input formControlName="accountNumber"
                              ngDefaultControl
                              name="accountNumber"
                              required
                              maxlength="17"
                              type="text"
                              [hasError]="isInvalid('accountNumber')"></ph-input>
                    <lf-control-messages hint [control]="model.controls['accountNumber']"></lf-control-messages>
                </ph-field>
            </ph-columns>
            <ph-field inline *ngIf="isPmc">
                <ph-checkbox formControlName="shareWithPmc"
                             ngDefaultControl
                             [checked]="model.get('shareWithPmc').value"
                             aria-label="Share with other organizations managed by this PMC"></ph-checkbox>
                <ph-label>Share with other organizations managed by this PMC</ph-label>
            </ph-field>
        </form>
    </ph-stack>

    <ph-actions slot="footer" *ngIf="isPreferencesLoaded && isManualAddEnabled && !isTermsAgreedTo && isMemberDataLoaded">
        <ph-button variant="secondary" mode="filled" [disabled]="isAgreeInFlight" (click)="cancelTermAgreement()">Cancel</ph-button>
        <ph-button [disabled]="isAgreeInFlight" (click)="saveTermAgreement()">I agree</ph-button>
    </ph-actions>

    <ph-actions slot="footer" *ngIf="isPreferencesLoaded && isManualAddEnabled && isTermsAgreedTo && isMemberDataLoaded">
        <ph-button variant="secondary" mode="filled" (click)="closed.emit(null)">Cancel</ph-button>
        <ph-button [disabled]="isSubmitInFlight" (click)="saveBankInfo()">Add bank account</ph-button>
    </ph-actions>
</ph-dialog>
